<template>
  <div class="ListingFavourite text-[1.9rem]">
    <template v-if="signedIn">
      <button v-show="!liked" @click.prevent="toggleLike" class="flex items-center">
        <i class="fal fa-heart text-gray-950 hover:text-primary active:text-primary"></i>
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
      <button v-show="liked" class="liked flex items-center" @click.prevent="toggleLike">
        <i class="fas fa-heart text-bt-blue-500"></i>
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
    </template>

    <template v-else>
      <button @click.prevent="removeGuestFavourite(listing.id)" v-show="guestLiked" class="flex items-center">
        <i class="fas fa-heart text-bt-blue-500"></i>
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
      <button @click.prevent="addToGuestFavourite" class="text-primary flex items-center" v-show="!guestLiked">
        <i class="fal fa-heart text-gray-950 hover:text-primary"></i>
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import { getters } from "@/components/UserFavouritesRenderless.js"
import ListingToFavourite from "@/lib/Listing/ToFavourite.js"

export default {
  name: "Listing.Favourite",
  props: {
    listing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      liked: false,
      buttonClasses: "flex items-center",
    }
  },
  mounted() {
    this.liked = this.listing.liked
  },
  methods: {
    addToGuestFavourite() {
      const favourite = ListingToFavourite(this.listing)
      this.addGuestFavourite(favourite)
      this.favouritesCount += 1
    },
    toggleLike() {
      const liked = this.liked
      const { favourites_count } = this.listing

      this.liked = !liked
      if (this.liked) {
        this.listing.favourites_count = favourites_count + 1
      } else {
        this.listing.favourites_count = favourites_count - 1
      }

      $.ajax({
        url: "/api/listings/favourites",
        type: liked ? "DELETE" : "POST",
        data: { listing_id: this.listing.id },
      })
        .done((_response) => {
          $.getScript("/listings/favourites/navbar")
          this.favouritesCount += liked ? -1 : 1
          if (typeof ga === "function") {
            ga("send", "event", "Favourited Artwork", "website", this.listing.title)
            dataLayer.push({
              event: "addtoFavorites",
              ArtworkName: this.listing.title,
            })
          }
        })
        .error((response) => {
          this.liked = liked
        })
    },
    ...mapActions("guest", {
      addGuestFavourite: "addFavourite",
      removeGuestFavourite: "removeFavourite",
    }),
  },
  computed: {
    signedIn() {
      return window.config.userSignedIn
    },
    guestLiked() {
      return this.favourites.map((l) => l.id).includes(this.listing.id)
    },
    ...getters,
    ...mapState("guest", ["favourites"]),
  },
}
</script>
